require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-much-should-i-save-for-college.json") })
        }
      }, "path---calculators-how-much-should-i-save-for-college");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-much-should-i-save-for-college!./.cache/json/calculators-how-much-should-i-save-for-college.json
// module id = 2006
// module chunks = 231608221292675